/**
 * Safe localStorage JSON helpers shared by the client instrumentation
 * stores (traffic tracker, analytics aggregates). No-ops server-side and
 * swallow quota / private-mode / parse failures — instrumentation must
 * never take the app down.
 */

const isBrowser = typeof window !== "undefined";
export function readJSON(key, fallback) {
  if (!isBrowser) return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}
export function writeJSON(key, value) {
  if (!isBrowser) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore quota / private mode
  }
}